module.exports = __webpack_public_path__ + "assets/icons/ic_store_24px.svg";